/* eslint-disable import/no-unresolved */
export default [
  {
    path: '/project/:alias/:projectAlias/file',
    component: () => import('./pages/page-project-files'),
    name: 'project-files',
    meta: { noScrollTop: true }
  },
  {
    path: '/project/:alias/:projectAlias/blob',
    component: () => import('./pages/page-project-files'),
    name: 'project-file-blob',
    meta: { noScrollTop: true }
  },
  {
    path: '/project/:alias/:projectAlias/edit',
    component: () => import('./pages/page-project-files'),
    name: 'project-file-edit',
    meta: { noScrollTop: true }
  },
  {
    path: '/project/:alias/:projectAlias/edit/create-blob',
    component: () => import('./pages/page-project-files'),
    name: 'project-file-create',
    props: true,
    meta: { noScrollTop: true }
  }
];
